// src/libs/utils/cookiesStorage/cookies.js
import Cookies from "js-cookie";

export const clearHksCookies = () => {
  const cookiesToClear = [
    "token",
    "username",
    "userGroup",
    "fullName",
    "id",
    "isHinduKhatikSamaj",
    "primaryRequirement",
    "district",
  ];

  cookiesToClear.forEach((cookieName) => {
    Cookies.remove(cookieName, { path: "/" });
    Cookies.remove(cookieName, { path: "/", secure: true });
  });
};
